module.exports = __webpack_public_path__ + "static/jixiao-1ac584b0e44357af5d40f59072f23df6.png";